<script>
	// TODO: perhaps use this to render an inital component with the signature and perhaps setup a type to script font and use that for signature and initial images
	// export let value;

	import { formatFileSize, getSizeInBytes, slugify } from "cando-util";
	import SignatureCanvas from "./SignatureCanvas.svelte";

	export let value;
	export let question;
	export let handleChange = () => {};
	export let label;
	export let readonly;
	export let disabled;

	$: name = `${slugify(label)}.png`;
	// $: if (name) {
	// 	if (value === undefined) value = {};
	// 	if (value[name] === undefined)
	// 		value[name] = {
	// 			name,
	// 			type: "image/png",
	// 			width: 400,
	// 			height: 200,
	// 		};
	// }

	let dataUrl = value?.[`${slugify(label)}.png`]?.dataUrl;
	let renderedDataUrl = value?.[`${slugify(label)}.png`]?.dataUrl;

	$: if (renderedDataUrl !== dataUrl) {
		console.log(`update ${name} values`);

		if (dataUrl) {
			const size = getSizeInBytes(dataUrl || "");
			value = {
				[name]: {
					name,
					dataUrl,
					type: "image/png",
					width: 400,
					height: 200,
					size,
					formattedSize: formatFileSize(size),
				},
			};
		} else {
			// if we only ever have one file for this input type then...
			value = undefined;
		}

		renderedDataUrl = dataUrl;

		handleChange(question);
	}
</script>

<!-- {#if value?.[name]}
	<SignatureCanvas
		bind:dataUrl={value[name].dataUrl}
		{disabled}
		{readonly}
		{label}
	/>
{/if} -->
<SignatureCanvas bind:dataUrl {disabled} {readonly} {label} />
